import {Scene} from "./Scene";
import {CameraMode, PointColorType, PointShape, PointSizeType} from "../defines";
import * as Potree from "../Potree";
import {BoxVolume, Measure, Profile, Utils} from "../Potree";

export class ConfigReader {

    constructor(viewer) {
        this.viewer = viewer;
    }

    readConfigJson(path, callback) {
        this.loadJSON(path, (jsonString) => {
            this.readConfigJsonString(jsonString);
        });
    }

    loadJSON(path, callback) {
        try {
            var xobj = new XMLHttpRequest();
            xobj.overrideMimeType("application/json");
            xobj.open('GET', path, true);
            xobj.onreadystatechange = () => {
                if(xobj.readyState == 4) {
                    if(xobj.status == "200") {
                        callback(xobj.responseText);
                    } else if(xobj.status == "404") {
                        alert("File '" + path + "' not found");
                    } else {
                        alert("Failed to fetch the config JSON File '" + path + "'");
                    }
                }
            }
            xobj.send(null);
        } catch (err) {
            alert("Failed to read the JSON File '" + path + "'\n" + err.message);
        }
    }

  stringifyFullConfig() {
      const hasViewerConfigs = this.viewer.configs && this.viewer.configs.length > 0;
      const fullConfig = {
        version: 2,
        configs: hasViewerConfigs ? this.viewer.configs : [this.getCurrentConfig()],
    };
    return JSON.stringify(fullConfig, null, 4);
  }

  addConfigPreset(name) {
    const currentConfig = this.getCurrentConfig();
    if (name) {
        currentConfig.name = name;
    }
    if (this.viewer.configs) {
        this.viewer.configs.push(currentConfig);
    } else {
        this.viewer.configs = [currentConfig];
    }
  }

  getCurrentConfig() {
    return {
      fov: this.viewer.getFOV(),
      enableEDL: this.viewer.getEDLEnabled(),
      useHQ: this.viewer.useHQ,
      pointBudget: this.viewer.getPointBudget(),
      pointSize: this.viewer.getPointSize(),
      camera: this.viewer.getCameraInfo(),
      pointclouds: this.viewer.getPointClouds(),
      meshes: this.viewer.getMeshes(),
      measurements: this.viewer.getMeasurements(),
      profiles: this.viewer.getProfiles(),
      volumes: this.viewer.getVolumes(),
      annotations: this.viewer.getAnnotations()
    };
  }

  stringifyMeasurements() {
    let measurements = {
      measurements: this.viewer.getMeasurements(),
      profiles: this.viewer.getProfiles(),
      volumes: this.viewer.getVolumes()
    }

    return JSON.stringify(measurements, null, 4);
  }

  stringifyMeasurementsAsTxt() {
    var measurements = this.viewer.getMeasurements();
    var points = [
        ...measurements.distances.map((distance) => distance.points).flat(),
        ...measurements.heights.map((distance) => distance.points).flat(),
        ...measurements.points,
    ]
    var result = points.map((point) => `${point.x} ${point.y} ${point.z}`);
    return result.join('\n');
  }

    parseJsonString(jsonString) {
        try {
            var config = JSON.parse(jsonString);
            return config;
        } catch(err) {
            alert("Failed to parse the JSON File: \n" + err.message);
        }
    }

    readConfigJsonString(configJson) {
        if (configJson) {
            const config = this.parseJsonString(configJson);
            if (config.version === 2) {
                const defaultConfig = config.configs[0];
                console.log('Loading Config new Version', defaultConfig);
                this.applyConfigJson(defaultConfig);
                this.viewer.configs = config.configs;
            } else {
                this.applyConfigJson(config)
                this.viewer.configs = [config];
            }
        }
    }

    applyConfigJson(config) {
        if(config) {
            this.tree = $(`#jstree_scene`);
            console.log('Loading Config..', config);

            let scene = new Scene(this.viewer);
            this.viewer.setScene(scene);

            this.viewer.setFOV(config.fov);
            this.viewer.setEDLEnabled(config.enableEDL);
            this.viewer.setUseHQ(config.useHQ === undefined ? true : config.useHQ);
            this.viewer.setPointBudget(config.pointBudget === undefined ? 100000000 : config.pointBudget);
            this.viewer.setPointSize(config.pointSize);

            let fitToScreen = false;
            if(config.camera) {
                this.viewer.setCameraPosition(config.camera.position);
                this.viewer.setCameraTarget(config.camera.target);
                this.viewer.setCameraMode(config.camera.projection == "orthographic" ? CameraMode.ORTHOGRAPHIC : CameraMode.PERSPECTIVE);
            } else {
                fitToScreen = true;
            }

            config.pointclouds.forEach((x, index) => {
                setTimeout(() => {
                    Potree.loadPointCloud(x.path, x.name, (e) => {
                        e.pointcloud.visible = x.isActive;

                        if (typeof x.position === 'object') {
                            e.pointcloud.position.set(x.position.x, x.position.y, x.position.z);
                        }
                        if (typeof x.scale === 'object') {
                            e.pointcloud.scale.set(x.scale.x, x.scale.y, x.scale.z);
                        }
                        if (typeof x.rotation === 'object' && x.rotation.x !== undefined) {
                            e.pointcloud.rotation.set(x.rotation.x, x.rotation.y, x.rotation.z);
                        }

                        this.viewer.scene.addPointCloud(e.pointcloud);
                        let material = e.pointcloud.material;
                        material.pointSizeType = x.pointSizeType === undefined ? PointSizeType.FIXED : x.pointSizeType;
                        material.shape = x.shape === undefined ? PointShape.SQUARE : x.shape;
                        material.size = x.pointSize === undefined ? 1 : x.pointSize;

                        const pC = x.pointColor;
                        if(pC) {
                            if(pC.brightness) {
                                material.rgbBrightness = pC.brightness;
                                material.intensityBrightness = pC.brightness;
                            }
                            if(pC.contrast) {
                                material.rgbContrast = pC.contrast;
                                material.intensityContrast = pC.contrast;
                            }
                            if(pC.gamma) {
                                material.rgbGamma = pC.gamma;
                                material.intensityGamma = pC.gamma;
                            }

                            if(pC.intensityRange)
                                material.intensityRange = pC.intensityRange;
                            if(pC.elevationRange)
                                material.elevationRange = pC.elevationRange;
                            if(pC.gradient)
                                material.gradient = Potree.Gradients[pC.gradient];

                            const hasRGB = pC.brightness || pC.contrast || pC.gamma;
                            const hasElevation = pC.elevationRange || pC.gradient;
                            const hasIntensity = pC.intensityRange;
                            if(hasRGB && hasElevation)
                                material.pointColorType = PointColorType.RGB_HEIGHT;
                            else if(hasIntensity)
                                material.pointColorType = PointColorType.INTENSITY;
                            else if(hasRGB)
                                material.pointColorType = PointColorType.RGB;
                            else if(hasElevation)
                                material.pointColorType = PointColorType.HEIGHT;
                        }

                        if(fitToScreen)
                            this.viewer.fitToScreen();
                    }, 100 * index);
                })
            });

            /*
                var loader = new THREE.PLYLoader();
                loader.load('./models/ply/ascii/dolphins.ply', function (geometry) {
                    scene.add( new THREE.Mesh( geometry ) );
                } );
            */
            if(config.meshes) {
                config.meshes.forEach(x => {
                    if(x.path.endsWith(".ply")) {
                        this.viewer.loadMeshPLY(x);
                    } else if(x.path.endsWith(".obj")) {
                        this.viewer.loadMeshOBJ(x);
                    }
                });
            }

            if(config.annotations) {
                config.annotations.forEach(x => {
                    if(Utils.annotationNodeIDs[x.title] == null) {
                        let position = [x.position.x, x.position.y, x.position.z];
                        let annotation = {
                            cameraPosition: x.cameraPosition ? [x.cameraPosition.x, x.cameraPosition.y, x.cameraPosition.z] : null,
                            cameraTarget: x.cameraTarget ? [x.cameraTarget.x, x.cameraTarget.y, x.cameraTarget.z] : null,
                            title: x.name,
                            visible: x.isActive
                        };

                        this.viewer.scene.addAnnotation(position, annotation);
                    }
                });
            }

            if (config.volumes) {
                config.volumes.forEach((x) => {
                    const newVolume  = new BoxVolume();
                    newVolume.name = x.name;

                    newVolume.position.set(x.position.x, x.position.y, x.position.z);
                    newVolume.scale.set(x.scale.x, x.scale.y, x.scale.z);
                    newVolume.scale.set(x.rotation.x, x.rotation.y, x.rotation.z);

                    newVolume.clip = true;
                    newVolume.modifieable = true;
                    newVolume.visible = x.isActive;

                    this.viewer.scene.scene.add(newVolume);
                })
            }

            if(config.measurements) {
                this.applyConfigMeasurements(config, true);
            }

            setTimeout(() => {
                this.viewer.sidebar.refreshConfigPresets();
            })
        }

    }

    applyConfigMeasurements(config, overrideMeasurements) {
        if(config.measurements.points) {
            config.measurements.points.forEach(x => {
                if(overrideMeasurements || Utils.measurementNodeIDs[x.name] == null) {
                    var point = [x.x, x.y, x.z];
                    var measure = new Measure();
                    measure.name = x.name;
                    measure.addMarker(point);
                    measure.showCoordinates = true;
                    measure.showDistances = false;
                    measure.maxMarkers = 1;
                    measure.visible = x.isActive;

                    this.scene.addMeasurement(measure);
                }
            });
        }

        if(config.measurements.distances) {
            config.measurements.distances.forEach(x => {
                if(overrideMeasurements || Utils.measurementNodeIDs[x.name] == null) {
                    const points = x.points.map((v, i, a) => [v.x, v.y, v.z]);
                    const measure = new Measure();
                    measure.name = x.name;
                    measure.visible = x.isActive;
                    points.forEach(y => measure.addMarker(y));

                    this.viewer.scene.addMeasurement(measure);
                }
            });
        }

        if(config.measurements.heights) {
            config.measurements.heights.forEach(x => {
                if(overrideMeasurements || Utils.measurementNodeIDs[x.name] == null) {
                    var points = x.points.map((v, i, a) => [v.x,v.y,v.z]);
                    var measure = new Measure();
                    measure.name = x.name;
                    measure.showHeight = true;
                    measure.showDistances = false;
                    measure.visible = x.isActive;
                    points.forEach(y => measure.addMarker(y));

                    this.viewer.scene.addMeasurement(measure);
                }
            });
        }

        if(config.profiles) {
            config.profiles.forEach(x => {
                if(overrideMeasurements || Utils.profileNodeIDs[x.name] == null) {
                    const points = x.points.map((v, i, a) => new THREE.Vector3(v.x,v.y,v.z));
                    const profile = new Profile();
                    profile.name = x.name;
                    profile.visible = x.isActive;
                    points.forEach(y => profile.addMarker(y));

                    this.viewer.scene.addProfile(profile);
                }
            });
        }

        if(config.volumes) {
            config.volumes.forEach(x => {
                if(overrideMeasurements || Utils.volumeNodeIDs[x.name] == null) {
                    var volume = new BoxVolume();
                    volume.name = x.name;
                    volume.clip = true;
                    volume.position.set(x.position.x, x.position.y, x.position.z);
                    volume.scale.set(x.scale.x, x.scale.y, x.scale.z);
                    volume.rotation.set(x.rotation.x, x.rotation.y, x.rotation.z);
                    volume.box.visible = false;
                    volume.label.visible = false;
                    volume.visible = x.isActive;

                    this.viewer.scene.addVolume(volume);
                }
            });
        }
    }
}

